import { Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveImportacionIdRar } from "../../../redux/actions/nte";
import { formatFormTitle } from "../../../util/breadcrumb";
import Breadcrumb from "../../commons/breadcrumb/Breadcrumb";
import HeaderForm from "../../commons/labels/HeaderForm";
import { StyledNte } from "../../styled/Prevencion";
import ConfeccionDelArchivoContainer from "./confeccionDelArchivo/ConfeccionDelArchivoContainer";
import EstablecimientoContainer from "./establecimientos/EstablecimientoContainer";
import ImportarNominasContainer from "./importarNominas/ImportarNominasContainer";
import PrePresentacionContainer from "./prePresentacion/PrePresentacionContainer";
import ResponsablesContainer from "./responsables/ResponsablesContainer";

const ImportarNTEContainer = () => {
  const dispatch = useDispatch();

  const nominaAdjuntadaExitosamente = useSelector(
    (state) => state.nte.importacionIdRar != null
  );

  const [form, setForm] = useState("Establecimiento");
  const [fromBread, setFromBread] = useState(false);
  const [breadcrumbFields, setBreadcrumbFields] = useState([form]);

  const titles = {
    Establecimiento: "Presentación de Nóminas de Trabajadores Expuestos a Riesgos - NTE",
    ConfeccionDelArchivo: formatFormTitle("ConfeccionDelArchivo"),
    Responsables: formatFormTitle("Responsables"),
    ImportarNóminas: "Importar Nóminas de Trabajadores Expuestos - NTE",
    PrePresentación: formatFormTitle("PrePresentación"),
  };

  const handleSetForm = (form) => {
    if (!breadcrumbFields.includes(form)) {
      setBreadcrumbFields([...breadcrumbFields, form]);
    }
    setForm(form);
  };

  useEffect(() => {
    return () => {
      dispatch(saveImportacionIdRar(null));
    };
  }, []);

  return (
    <Paper
      style={{ overflow: "hidden", height: "fit-content", minHeight: 650 }}
    >
      <HeaderForm
        title={titles[form]}
      />
      <StyledNte.BreadcrumbContainer>
        <Breadcrumb
          setForm={setForm}
          setFields={setBreadcrumbFields}
          fields={breadcrumbFields}
          setFromBread={() => setFromBread(true)}
          form={form}
          disableNavigationBackwards={
            nominaAdjuntadaExitosamente ? true : false
          }
        />
      </StyledNte.BreadcrumbContainer>
      <div style={{ margin: 20 }}>
        {
          {
            Establecimiento: (
              <EstablecimientoContainer
                nextForm={handleSetForm}
                fromBread={fromBread}
              />
            ),
            ConfeccionDelArchivo: <ConfeccionDelArchivoContainer nextForm={handleSetForm} />,
            Responsables: <ResponsablesContainer nextForm={handleSetForm} />,
            ImportarNóminas: ( 
              <ImportarNominasContainer nextForm={handleSetForm} />
            ),
            PrePresentación: <PrePresentacionContainer />,
          }[form]
        }
      </div>
    </Paper>
  );
};

export default ImportarNTEContainer;
